import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {CapacityFrameworkRole} from "@/types";

const page = usePage()

const role = computed<CapacityFrameworkRole | null>(() => {
    return page.props.role as CapacityFrameworkRole | null
})

const isAdminOrEditor = computed(() => {
    return role.value === 'admin' || role.value === 'editor'
})

const isAdmin = computed(() => {
    return role.value === 'admin'
})

const isGuest = computed(() => {
    return role.value === null
})

export const useCapacityFramework = () => {
    return {
        role,
        isAdminOrEditor,
        isAdmin,
        isGuest,
    }
}
